import { createApp } from "vue"
import SiteIcons from "./SiteIcons.vue"
// import { devLog } from "@/utils"

const icons = createApp(SiteIcons)

export const createIconsDemo = (id = 'icons-demo') => {
  // devLog(`astra-icons-demo:create #${id}`)

  const host = document.getElementById(id)

  if (!host) return
  icons.mount(`#${id}`)
}
